import { render, staticRenderFns } from "./BaseRuler.vue?vue&type=template&id=671a942a&"
import script from "./BaseRuler.vue?vue&type=script&lang=js&"
export * from "./BaseRuler.vue?vue&type=script&lang=js&"
import style0 from "./BaseRuler.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports